export default "__VITE_ASSET__D7ZwLu0r__"